import PassengerType from "@CheckOrder/types/Passenger.type";
import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";

export const isPassengerVehicle = (passenger: PassengerType | VehicleAddonType): passenger is VehicleAddonType => (
    passenger.type === 'Vehicle'
)